import {
 Skeleton, Table, TableCell, TableHeading
} from '@nike/eds';
import PropTypes from 'prop-types';
import React from 'react';

import { NPOS } from '../../../../utils/constants';
import { createArray } from '../../../../utils/ej-utils';
import { getColAlignment } from '../nposUtils';

const getLoaders = (colId) => {
  if (colId === 'transactionStartDate') {
    return (
      <div className="d-sm-flx flx-dir-sm-c" style={{ gap: '10px' }}>
        <Skeleton as="div" height={13} width={59} />
        <Skeleton as="div" height={13} width={38} />
      </div>
    );
  }
  return <Skeleton as="div" height={16} width={59} />;
};

const TableLoading = ({ columns }) => (
  <div className="npos-table">
    <div className="d-sm-flx transactions-msg">
      <Skeleton as="span" height={16} width={282} />
    </div>
    <Table
      style={{
        backgroundColor: '#fff',
        width: '100%',
      }}
    >
      <thead>
        <tr>
          {columns.map((column, idx) => (
            <TableHeading
              key={column.id}
              style={{ minWidth: '50px', textAlign: 'center' }}
            >
              <div
                className={`d-sm-flx flx-dir-r flx-ai-sm-c flx-jc-sm-${getColAlignment(
                  idx,
                  columns.length
                )}`}
                style={{ minHeight: '50px' }}
              >
                <div className="d-sm-flx flx-dir-r" style={{ gap: '10px' }}>
                  <div>
                    <Skeleton as="div" height={13} width={59} />
                  </div>
                </div>
              </div>
            </TableHeading>
          ))}
        </tr>
      </thead>
      <tbody>
        {createArray(NPOS.SKELETON_ROW_COUNT).map((row) => (
          <tr key={row}>
            {columns.map(({ id }, idx) => (
              <TableCell key={id} style={{ minWidth: '50px' }}>
                <div
                  className={`d-sm-flx flx-jc-sm-${getColAlignment(
                    idx,
                    columns.length
                  )}`}
                  style={{ flexGrow: 1 }}
                >
                  {getLoaders(id)}
                </div>
              </TableCell>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);

TableLoading.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default TableLoading;
